/**
 * `/r/CY-XXXXXXXX` frontend bridge.
 *
 * The Kubernetes ingress routes `/api/*` to the backend and everything else
 * to the frontend, so the short + memorable `cyannect.com/r/CY-...` URL
 * lands here first. We immediately forward to `/api/r/{cy_ref}` where the
 * backend validates the token, records the click, and 302s the browser to
 * the merchant. The user sees a brief "Redirecting…" splash so a slow API
 * response doesn't look like a broken link.
 */
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function ReferralRedirect() {
  const { cyRef } = useParams();

  useEffect(() => {
    if (!cyRef) return;
    // Full backend URL (works both from the merchant and app subdomains).
    const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    window.location.replace(`${backend}/api/r/${cyRef}`);
  }, [cyRef]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="referral-redirect">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto rounded-full border-4 border-cyan-500 border-t-transparent animate-spin" />
        <div className="mt-4 text-sm font-medium text-slate-700">Redirecting you to the merchant…</div>
        <div className="mt-1 text-xs text-slate-400">If this takes more than a moment, refresh the page.</div>
      </div>
    </div>
  );
}
